import apiClient from "./client";

export function sendGeoJson(payload) {
  return apiClient.post("/overlays", payload).then((res) => res.data);
}

// Fetch overlays for a specific customer
export function getOverlays() {
  return apiClient.get(`/overlays/all/`).then((res) => res.data);
}

export function getOverlayGeoJsonById(id) {
  return apiClient.get(`/overlays/item/${encodeURIComponent(id)}/geojson`).then((res) => res.data);
}

export function deleteOverlay(id) {
  return apiClient.delete(`/overlays/${id}`).then((res) => res.data);
}

export function createOverlay(data) {
  return apiClient.post("/overlays", data).then(res => res.data);
}

export function updateOverlay(data) {
  // Use POST, not PUT, and do not include the id in the URL
  return apiClient.post("/overlays", data).then(res => res.data);
}

/**
 * Import Outdooractive content (Tours/POIs) as map overlays.
 * Content is shown as a standalone, customer-wide "Outdooractive" map layer;
 * zoneId is optional (leave blank to keep it untagged to any zone).
 * One-way, read-only. Returns a structured summary (created/updated/skipped/errors).
 * @param {{ zoneId?: string, projectKey?: string, includeTours?: boolean, includePois?: boolean }} payload
 */
export function importFromOutdooractive(payload) {
  return apiClient
    .post("/overlays/outdooractive/import", payload, { timeout: 120000 })
    .then((res) => res.data);
}

/**
 * Import public OuterSpatial data (Areas/Trails/POIs) into a zone as map overlays.
 * Kept alongside Outdooractive for comparison. One-way, read-only.
 * @param {{ zoneId: string, orgId?: string, includeAreas?: boolean, includeTrails?: boolean, includePois?: boolean }} payload
 */
export function importFromOuterSpatial(payload) {
  return apiClient
    .post("/overlays/outerspatial/import", payload, { timeout: 120000 })
    .then((res) => res.data);
}

/**
 * Upload a GeoJSON file for a zone
 * @param {File} file - The GeoJSON file to upload
 * @param {string} zoneId - The zone ID to associate with
 * @param {string} overlayName - Optional name for the overlay
 */
export function uploadGeoJsonFile(file, zoneId, overlayName = null) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("zoneId", zoneId);
  if (overlayName) {
    formData.append("overlayName", overlayName);
  }
  
  return apiClient.post("/overlays/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000, // 60 second timeout for file uploads
  }).then((res) => {
    return res.data;
  }).catch((error) => {
    throw error;
  });
}

